module.exports = __webpack_public_path__ + "static/media/about-background.60e61831.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/About/assets/img/about-background.jpg
// module id = 1519
// module chunks = 0